/* eslint-disable react/require-default-props */
import * as React from 'react';
import { useEffect } from 'react';

import useStores from './hooks/useStores';

import Layout from './components/Layout';
import Routes from './Routes';

import * as S from './styles/app';
import { CardList, CardCompanyList } from './types';

interface PropTypes {
  defaultCardList?: CardList;
  companyList?: CardCompanyList;
  amountPaid: number;
  onClickPayment?: React.MouseEventHandler<HTMLElement>;
  onClickCancel?: React.MouseEventHandler<HTMLElement>;
  onUpdatedCardData?: (cardList: CardList) => void;
}

function CardWalletApp({
  defaultCardList,
  companyList,
  amountPaid,
  onClickPayment,
  onClickCancel,
  onUpdatedCardData,
}: PropTypes) {
  const { AppHandler, CardWallet } = useStores();

  useEffect(() => {
    AppHandler.setHandler({ onClickPayment, onClickCancel, onUpdatedCardData });
    CardWallet.initial({ defaultCardList, companyList, amountPaid });
  }, []);

  return (
    <S.Container id="payments-app-container">
      <Layout>
        <Routes />
      </Layout>
    </S.Container>
  );
}

export default CardWalletApp;
